import { render, staticRenderFns } from "./EventRegister.vue?vue&type=template&id=0b794d5e&"
import script from "./EventRegister.vue?vue&type=script&lang=js&"
export * from "./EventRegister.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports